<template>
    <div :class="getSettings.header.minimaze ? 'header_wrap' :'header_wrap-minimaze'">
        <!--<audio id="music" src="../../assets/sound/icq-aska.mp3"></audio>-->
        <div class="header-slider">
            <transition
                enter-active-class="animated slideInDown"
                leave-active-class="animated slideOutDown">
                <div class="header_slide-one" v-show="slide === 'profit'">
                    <widget-currency
                        v-for="(items, index) in currency" :key="index"
                        :nameCurrency= "items.name"
                        :symbol = "items.name">
                    </widget-currency>
                    <!--<widget-income
                        :incomeTitle = "'Текущий доход'">
                    </widget-income>-->
                </div>
            </transition>
            <transition
                enter-active-class="animated slideInDown"
                leave-active-class="animated slideOutDown">
                <div class="header_slide-one" v-show="slide === 'pairs'">
                     <widget-income
                        :incomeTitle = "'Баланс'"
                        :type = "'balance'">
                    </widget-income>
                    <widget-income
                        :incomeTitle = "'Средства'"
                        :type = "'equity'">
                    </widget-income>
                    <widget-income
                        :incomeTitle =  "'Чистая прибыль'"
                        :type="'plAbs'">
                    </widget-income>
                    <!--<widget-income
                        :incomeTitle = "'Текущий доход'">
                    </widget-income>-->
                    <common-profit></common-profit>
                    <div class="currency_income">
                        <widget-income
                            :incomeTitle = "'Изменения за сутки'"
                            :type="'changeDay'">
                        </widget-income>
                    </div>
                    <widget-prognosis>
                    </widget-prognosis>
                </div>
            </transition>
            <transition
                enter-active-class="animated slideInDown"
                leave-active-class="animated slideOutDown">
                <div class="header_slide-one" v-show="slide === 'quote'">
                    <quote-widget
                        v-for="(items, index) in quotes" :key="index"
                        :pair="items" @newSymbol = setNewQuote($event,index)>
                    </quote-widget>
                    <!--<widget-income
                        :incomeTitle = "'Текущий доход'">
                    </widget-income>-->
                </div>
            </transition>
        </div>
        <div :class="getSettings.header.minimaze ? 'arrow_carusel' : 'arrow_carusel arrow_carusel-minimaze'">
            <i class="icon-icon-down" v-if="!getSettings.autoSlider" @click="prevCarusel"></i>
            <div class="arrow_carusel-switch">
                <switcher @switchStatus = "switchSlide($event)" :classSwitcher = "getSettings.autoSlider"></switcher>
                <div class="arrow_carusel-switch-text" v-show="getSettings.header.minimaze"
                    :class="getSettings.autoSlider ? 'color-green':'color-red'">
                    auto
                </div>
            </div>
        </div>
        <div class="headerBarLine">
            <round></round>
        </div>
        <!--<div class="headerBarLine_big-open">
            <widget-barline
                :variant="'openPositions'"
                :title="'% ОТК. приб. сд.'"></widget-barline>
        </div>
        <div class="headerBarLine_big-max">
            <widget-barline class="headerBarLine_big"
                :variant="'maxdd'"
                :title="'Max.DD'"></widget-barline>
        </div>-->
        <div class="headerStatistic">
            <widget-statistica></widget-statistica>
        </div>
        <div class="headerClocks-gmt">
            <clock @changeClock = "setNewTime($event)"
                :title="clockTitle"
                :zone="clockZone">
            </clock>
        </div>
        <div class="headerClocks">
            <clock
                :title="'Лондон (GMT)'"
                :zone="0"></clock>
            <clock
                :title="'Нью-ЙОРК (GMT-5)'"
                :zone="-5">
            </clock>
            <clock
                :title="'Токио (GMT+9)'"
                :zone="9"
            ></clock>
        </div>
        <head-switcher></head-switcher>
        <div class="notification__bell" @click = "showPopup" >
            <div v-show="bell" :class="getSettings.header.minimaze ? 'notification__count' : 'notification__count notification__count-mini'">
                {{countEvents}}
            </div>
            <i class="icon-bell"
                :class = "bell ? 'color-green' : ''"></i>
        </div>
        <transition
                enter-active-class="fade-enter-active"
                leave-active-class="fade-leave-active" mode="out-in">
            <notification v-show="notification"
                @close = "closePopup($event)"
                @bell = "alarm($event)"
                @bellAudio = "signalNotificationGC"></notification>
        </transition>
        <transition
                enter-active-class="fade-enter-active"
                leave-active-class="fade-leave-active" mode="out-in">
            <notificationLastOrders v-show="notificationLastOrders"
                @lastOrders="startLastOrders"></notificationLastOrders>
        </transition>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import widgetCurrency from "./sig-header-widget";
import widgetPrognosis from "./sig-header-widget-prognosis";
import widgetBarLine from "./sig-header-widget-barline";
import widgetChart from "./sig-round-chart";
import widgetStatistica from "./sig-header-widget-statistica";
import widgetIncome from "./sig-header-widget-income";
import widgetQuote from "./header-quote-widget"
import notificationPopup from "./sig-notification-popup";
import notificationPopupLastOrders from "./sig-last-notification-popup";
import Switcher from "../ui-components/switcher";
import Clock from "./sig-clock-widget";
import HeaderMinimazeSwitcher from "./sig-header-minimaze-switcher";
import Counter from "./sig-user-counter";
import CommonProfitWidget from "./common-profit-widget"

export default {
  components: {
    "widget-currency": widgetCurrency,
    "quote-widget": widgetQuote,
    "widget-prognosis": widgetPrognosis,
    "widget-barline": widgetBarLine,
    "widget-statistica": widgetStatistica,
    "widget-income": widgetIncome,
    "notification": notificationPopup,
    "notificationLastOrders":notificationPopupLastOrders,
    "switcher": Switcher,
    "clock":Clock,
    "counter":Counter,
    "round":widgetChart,
    "head-switcher":HeaderMinimazeSwitcher,
    "common-profit":CommonProfitWidget
  },
  data() {
    return {
      currency: [
        { name: "EURUSD" ,title:"EUR/USD"},
        { name: "GBPUSD" ,title:"GBP/USD"},
        { name: "USDJPY" ,title:"USD/JPY"},
        { name: "USDCHF" ,title:"USD/CHF"},
        { name: "USDCAD" ,title:"USD/CAD"},
        { name: "EURGBP" ,title:"EUR/GBP"}
      ],
      quotes: [
        { name: "EURUSD" ,title:"EUR/USD"},
        { name: "GBPUSD" ,title:"GBP/USD"},
        { name: "USDJPY" ,title:"USD/JPY"},
        { name: "USDCHF" ,title:"USD/CHF"},
        { name: "AUDUSD" ,title:"AUD/USD"},
        { name: "NZDUSD" ,title:"NZD/USD"}
      ],
      notification:false,
      notificationLastOrders:false,
      slide: 'profit',
      sliderItems: ['profit','pairs','quote'],
      bell: false,
      interval:null,
      countEvents:null,
      clockTitle:'Москва (GMT +3)',
      clockZone:3
    };
  },
  computed: {
      ...mapGetters({
          getSettings:'usersets/getSettings'
      })
  },
  methods: {
    setNewTime(optionsTime) {
        this.clockTitle = optionsTime.titleZone;
        this.clockZone = optionsTime.zone;
    },
    setNewQuote(symbol,index) {
        this.quotes[index].name = symbol.symbol;
        this.quotes[index].title = symbol.title;
    },
    startLastOrders () {
        this.notificationLastOrders = true;
        setTimeout(()=> {
            this.notificationLastOrders = false
        },8000);
    },
    switchSlide(carusel) {
        if (carusel) {
        this.interval = setInterval(() => {
                if(this.slide === 'profit') {
                    this.slide ='pairs';
                    return
                }
                if(this.slide === 'pairs') {
                    this.slide = 'quote'
                    return
                }
                if (this.slide === 'quote') {
                    this.slide = 'profit'
                    return
                }
            }, 6000);
        }
        else {
            clearInterval(this.interval)
        }
        this.$store.dispatch('usersets/saveSettingsHeaderAuto',carusel)
    },
    prevCarusel () {
        if(this.slide === 'profit') {
            this.slide ='pairs';
            return
        }
        if(this.slide === 'pairs') {
            this.slide = 'quote'
            return
        }
        if (this.slide === 'quote') {
            this.slide = 'profit'
            return
         }
    },
    showPopup() {
        this.notification = true;
        this.bell = false;
    },
    closePopup(event)
    {
        this.notification = event;
        this.bell = false;
    },
    signalNotificationGC() {
        const myAudio = new Audio;
        myAudio.src = (require("../../assets/sound/icq-aska.mp3"));
        let promise = myAudio.play();
        //window.document.querySelector('audio').play();
        if (promise !== undefined) {
            promise.then(_ => {
                //Auto
                myAudio.play();
            }).catch(error => {
                //Error
            });
        }
    },
    alarm(e) {
        this.bell = e.status;
        this.countEvents = e.count;
        //this.notification = e;
        //this.signalNotificationGC();
    }
  },
  mounted() {
    this.switchSlide(this.getSettings.autoSlider);
  }
};
</script>
<style lang="less" scoped>
@keyframes change-height {
    from {
        max-height: 88px;
    }
    to {
        max-height: 40px;
    }
}
@keyframes change-height-full {
    from {
        max-height: 40px;
    }
    to {
        max-height: 88px;
    }
}
@keyframes change-top {
    from {
        top: 50px;
    }
    to {
        top: 20px;
    }
}
@keyframes change-top-full {
    from {
        top: 20px;
    }
    to {
        top: 50px;
    }
}
@keyframes slideIn {
  from {
    transform: translateX(100vw);
  }
  to {
    transform: translateX(0px);
  }
}

@keyframes slideOut {
  from {
    transform: translateX(0px);
  }
  to {
    transform: translateX(100vw);
  }
}

.fade-enter-active {
  animation: slideIn 2s !important;
}

.fade-leave-active {
  animation: slideOut 2s forwards !important;
}

.header_wrap {
  animation: change-height-full 0.6s ease-in 1;
  width: 100%;
  display: flex;
  max-height: 88px;
  justify-content: space-between;
  &-minimaze {
    animation: change-height 0.6s ease-in 1;
    max-height: 40px;
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
}
.headerClocks {
    display: flex;
}

.header-slider {
  position: relative;
  flex-grow: 1;
}
.header_slide-one {
  display: flex;
  width: 100%;
  justify-content: space-between;
  background: #324258;
  position: absolute;
  max-height: 88px;
}

.header_slide-second {
  display: flex;
  width: 100%;
  justify-content: space-between;
  background: #324258;
  position: relative;
  max-height: 88px;
}

.notification {
    &__bell {
        background-color: #3d536b;
        min-width: 32px;
        min-height: 88px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        color: #718da8;
        font-size: 23px;
        align-self: center;
        text-align: center;
        display: flex;
        align-items: center;
        margin-left: 1px;
        cursor: pointer;
        margin-right: 4px;
    }
    &__count {
        animation: change-top-full 0.6s ease-in 1;
        position: absolute;
        top: 50px;
        margin-left: 5px;
        font-size: 12px;
        font-family: Arimo;
        padding: 2px;
        background: #00ffd0;
        border-radius: 12px;
        border: 1px solid #293546;
        color: #293546;
        &-mini {
            animation: change-top 0.6s ease-in 1;
            top: 20px;
        }
    }
}
.arrow_carusel {
    background-color: #3d536b;
    width: 40px;
    height: 88px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    color: #718da8;
    font-size: 18px;
    align-self: center;
    text-align: center;
    display: flex;
    align-items: center;
    margin-left: 0px;
    cursor: pointer;
    margin-right: 1px;
    display: flex;
    &-minimaze {
        //height: 40px;
        animation: change-height 0.6s ease-in 1;
        max-height: 40px;
        i {
            max-height: 18px;
        }
    }
    &-switch {
        flex-grow: 1;
        flex-basis: 44px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        &-text {
            font-family: Arimo;
            font-size: 10px;
            font-weight: bold;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.6;
            letter-spacing: 0.4px;
            color: #aabed2;
            text-transform: uppercase;
            margin-top: 4px;
            &-minimaze {
                display: none;
            }
        }
    }
}

.arrow_carusel i {
    flex-grow: 1;
    flex-basis: 43px;
    display: flex;
    align-items: center;
    margin: 0 auto;
    width: 100%;
    justify-content: center;
    &:first-child {
        border-bottom: 1px solid #374b62;
    }
}

.notification__bell i {
    flex-grow: 1;
    display: flex;
    align-items: center;
    margin: 0 auto;
    width: 100%;
    justify-content: center;
    &:first-child {
        border-bottom: 1px solid #374b62;
    }
}
@media screen and (max-width: 1559px) {
    .arrow_carusel {
        margin-right: 0px;
    }
    .headerStatistic {
        display: none;
    }
    .header-slider {
        //display: none;
    }
    .currency_income {
        //display: none;
    }
}

@media screen and (max-width: 1919px) {
  .headerBarLine {
    display: none;
  }
  .headerClocks-gmt {
      display: none;
  }
}
@media screen and (max-width: 2240px) {
  .headerBarLine_big-open {
    display: none;
  }
}
@media screen and (max-width: 2483px) {
  .headerBarLine_big-max {
    display: none;
  }
  .headerClocks {
      display: none;
  }
}
</style>
